import React, { Fragment } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Request from '../../utils/request';
import utils from "../../utils/utils";
import PropTypes from "prop-types";
import px2rem from '../../utils/px2rem';
import fetchH5PreApiRequestData from '../../utils/H5PreApiFetch';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import './style.less';

const placeholder = 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png';
class PipelineProductLayout3 extends React.Component {
  constructor(props) {
    super(props);
    let { theme, cardBaseConfig = {}, goodsDataConfig = {}, tabList = [], switchGroup = [] } = props.config;
    const showNum = cardBaseConfig.displayLineNum === '1行'? 3 : 6;
    const showAll = props.config.itemList.length <= showNum ? true : false;
    const initList = goodsDataConfig.sortType === '自定义排序' ? props.config.itemList.map(item => {
      return {
        ...item,
        title: item.title,
        url: item.url,
        image: item.image || placeholder,
        price: ''
      };
    }) : props.config.itemList.map(item => {
      return {
        ...item,
        image: placeholder,
        price: ''
      };
    });
    let initTabList = [];
    if (theme === 'AI主题') {
      tabList =  switchGroup;
    }
    initTabList = tabList.map(tabItem => {
      if (tabItem.goodsDataConfig.sortType === '自定义排序') {
        tabItem.itemList = tabItem.itemList.map(item => {
          return {
            ...item,
            title: item.title,
            url: item.url,
            image: item.image || placeholder
          }
        });
        tabItem['showAll'] = tabItem.itemList.length <= showNum ? true : false;
        tabItem['showNum'] = showNum;
      } else {
        tabItem.itemList = tabItem.itemList.map(item => {
          return {
            ...item,
            image: placeholder
          };
        });
        tabItem['showAll'] = tabItem.itemList.length <= showNum ? true : false;
        tabItem['showNum'] = showNum;
      }
      return tabItem;
    });

    this.state = {
      tabList: initTabList,
      list: initList,
      currentIdx: 0,
      showNum: showNum,
      showAll: showAll,
      tabFixed: false
    }

    this.isIframe = utils.getParams('isIframe') == 1;
    this.initList = initList;
    this.sortTypeMap = {
      '自定义排序': 0,
      '销量': 4,
      'GMV': 6,
      '上新时间': 8,
      '热度': 18,
    };
    this.saleTypeMap = {
      '默认': 4,
      '近1天': 10,
      '近7天': 12,
      '近14天': 14,
      '近30天': 16
    }
    this.compOffsetTop = 0;
    this.initLayoutRowScroll = false;
    this.scrollState = 'paused';
    this.scrollAnimation = null;
    this.isScrollEnd = false;
    this.delayTimeout = null;
    this.inViewArea = false;
    this.pageId = utils.getPageId();
    this.top_id = utils.getParams('top_id');
  }

  async componentDidMount() {
    const {theme, cardBaseConfig, tabConfig } = this.props.config;

    if (theme === 'AI主题') {
      this.getTabListData();
    } else {
      if (tabConfig.tabType === '无Tab') {
        if (this.props['customAttributes']['data-component-id'] == 'pipeline-productLayout3-1770192375034') {
          this.getH5PreApiRequestData();
        }
        this.getItemListData();
      } else {
        this.getTabListData();
      }
    }

    if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum) && cardBaseConfig.isAutoCarousel === '是') {
      window.addEventListener('scroll', this.onScroll, true);
    }
  }

  componentWillUnmount() {
    const { cardBaseConfig } = this.props.config;
    if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum) && cardBaseConfig.isAutoCarousel === '是') {
      window.removeEventListener('scroll', this.onScroll, true);
    }
  }

  getH5PreApiRequestData = async() => {
    const { cardBaseConfig, goodsDataConfig } = this.props.config;
    const { list } = this.state;
    let { url, params } = this.getIdsReqConf(list, goodsDataConfig);
    const data = await fetchH5PreApiRequestData({
      url: url,
      method: 'post',
      params,
      isH5PreApi: true
    });
    const showNum = cardBaseConfig.displayLineNum === '1行'? 3 : 6;
    let result = data.List || [];
    if (this.pageId == '17701912601330096' && this.props['customAttributes']['data-component-id'] == 'pipeline-productLayout3-1770192375034' && this.top_id) {
      // 2026情人节会场指定页面，指定组件ID，顶部商品置顶（基于配色ID）
      const topGoodsIdx = result.findIndex((item) => item.id == this.top_id);
      if (topGoodsIdx >= 0) {
        const topGoods = result[topGoodsIdx];
        result.splice(topGoodsIdx, 1);
        result.unshift(topGoods);
      }
    }
    const showAll = result.length <= showNum ? true : false;
    this.setState({
      list: result,
      showAll
    }, () => {
      if (this.compRef) {
        this.compOffsetTop = this.compRef.offsetTop; 
      }
      if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum) && cardBaseConfig.isAutoCarousel === '是') {
        this.onScrollLayoutRow();
      }
    });
  }

  getItemListData = async() => {
    const {cardBaseConfig, goodsDataConfig, itemCollectList } = this.props.config;
    const showNum = cardBaseConfig.displayLineNum === '1行'? 3 : 6;
    const { list } = this.state;
    const { productType } = goodsDataConfig;
    let result = [], showAll = true;
    if (['商品id', '配色id', 'skuId'].includes(productType)) {
      result = await this.getListData(list, goodsDataConfig);
    } else {
      const collectIds = await this.getCollectIds(itemCollectList, goodsDataConfig);
      result = await this.getCollectListData(collectIds, goodsDataConfig);
    }
    showAll = result.length <= showNum ? true : false;
    this.setState({
      list: result,
      showAll
    }, () => {
      if (this.compRef) {
        this.compOffsetTop = this.compRef.offsetTop; 
      }
      if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum) && cardBaseConfig.isAutoCarousel === '是') {
        this.onScrollLayoutRow();
      }
    });
  }

  getTabListData = async() => {
    const { cardBaseConfig } = this.props.config;
    const showNum = cardBaseConfig.displayLineNum === '1行'? 3 : 6;
    const { tabList } = this.state;
    let result = [], showAll = true;
    for (let index = 0; index < tabList.length; index++) {
      const getDataFunc = async(delayTimeout) => {
        const { productType } = tabList[index].goodsDataConfig;
        if (['商品id', '配色id', 'skuId'].includes(productType)) {
          result = await this.getListData(tabList[index].itemList, tabList[index].goodsDataConfig);
        } else {
          const collectIds = await this.getCollectIds(tabList[index].itemCollectList, tabList[index].goodsDataConfig);
          result = await this.getCollectListData(collectIds, tabList[index].goodsDataConfig);
        }
        showAll = result.length <= showNum ? true : false;
        tabList[index]['itemList'] = result;
        tabList[index]['showAll'] = showAll;
        tabList[index]['showNum'] = showNum;
        this.setState({
          tabList
        }, () => {
          if (delayTimeout) {
            clearTimeout(delayTimeout); 
          }
        });
      }
      if (index === 0) {
        await getDataFunc();
        if (this.compRef) {
          this.compOffsetTop = this.compRef.offsetTop;
        }
        if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum) && cardBaseConfig.isAutoCarousel === '是') {
          this.onScrollLayoutRow();
        }
      } else {
        const delayTimeout = setTimeout(async() => {
          getDataFunc(delayTimeout);
        }, 2000);
      }
    }
  }

  getIdsReqConf = (initList = [], goodsDataConfig = {}) => {
    const { productType, sortType, dateRange, shihuoSubsidy } = goodsDataConfig;
    let reqUrl = '';

    switch (productType) {
      case '商品id':
        reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur';
        break;
      case '配色id':
        reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur';
        break;
      case 'skuId':
        reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur';
        break;
      case '商品集合id':
        reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur';
        break;
      case '配色集合id':
        reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur';
        break;
      default:
        break;
    }

    let sort_tag = 0;
    if (sortType === '销量') {
      if (!dateRange || dateRange === '默认') {
        sort_tag = 4
      } else {
        sort_tag = this.saleTypeMap[dateRange]
      }
    } else {
      sort_tag = this.sortTypeMap[sortType]
    }

    const filter_subsidy = shihuoSubsidy === '是' ? 1 : 0;
    const from = this.props.specialApiFrom || '';
    const itemList = JSON.parse(JSON.stringify(initList));

    const ids = itemList.map((item) => {
      if (typeof item === 'number') {
        return Number(item) || 0;
      } else {
        return Number(item.id) || 0;
      }
    });

    const config = {
      url: reqUrl,
      params: {
        filter_subsidy,
        sort_tag,
        from,
        ids
      },
      itemList
    }

    return config;
  }

  getListData = async(initList = [], goodsDataConfig = {}) => {
    const { cardBaseConfig } = this.props.config;
    const { productType, sortType, dateRange } = goodsDataConfig;
    let { url, params, itemList } = this.getIdsReqConf(initList, goodsDataConfig);
    const result = await Request({
      url,
      method: "post",
      withCredentials: true,
      data: params
    });
    const { status, data } = result.data;
    if (status === 0) {
      const list = this.handleListData({data, itemList, cardBaseConfig, productType, sortType, dateRange});
      return list;
    }
  }

  // 处理列表数据
  handleListData = ({data, itemList, cardBaseConfig, productType, sortType, dateRange} = {}) => {
    const list = data.List || [];
    const notFoundList = data.NotFound || [];
    if (sortType === '自定义排序') {
      
      itemList.forEach((product) => {
        const customItem = list.find((item) => item.id == product.id);
          if (sortType === '销量') {
            switch (dateRange) {
              case '近1天':
                customItem.sell_point = customItem.realSaleNum;
                customItem.sell_point_str = String(customItem.realSaleNum);
                break;
              case '近7天':
                customItem.sell_point = customItem.realSaleNum7;
                customItem.sell_point_str = String(customItem.realSaleNum7);
                break;
              case '近14天':
                customItem.sell_point = customItem.realSaleNum14;
                customItem.sell_point_str = String(customItem.realSaleNum14);
                break;
              case '近30天':
                customItem.sell_point = customItem.realSaleNum30;
                customItem.sell_point_str = String(customItem.realSaleNum30);
                break;
              default:
                break;
            }
          }

          if (customItem && customItem.id != '0') {
            const optionsAssign = {
              image: productType !== '商品id' ? ((product.image && product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2') < 0) ? product.image : customItem.image) : customItem.image,
              price: productType !== '商品id' ? (product.price || customItem.price) : customItem.price,
              title: product.useCustomName ? product.name || customItem.title : customItem.title,
              cornerMark: product.cornerMark || cardBaseConfig.cornerMark,
              url: product.url || customItem.url,
            }
            Object.assign(product, {
              ...customItem,
              ...optionsAssign
            })
          }
      });
      if (notFoundList.length > 0) {
        // 删除 notFoundList 中存在的商品
        itemList = itemList.filter(item => {
          const notFound = notFoundList.find(val => val == item.id);
          return notFound ? false : true
        });
      }

      return itemList;

    } else {

      list.forEach((product) => {
        if (sortType === '销量') {
          switch (dateRange) {
            case '近1天':
              product.sell_point = product.realSaleNum;
              product.sell_point_str = String(product.realSaleNum);
              break;
            case '近7天':
              product.sell_point = product.realSaleNum7;
              product.sell_point_str = String(product.realSaleNum7);
              break;
            case '近14天':
              product.sell_point = product.realSaleNum14;
              product.sell_point_str = String(product.realSaleNum14);
              break;
            case '近30天':
              product.sell_point = product.realSaleNum30;
              product.sell_point_str = String(product.realSaleNum30);
              break;
            default:
              break;
          }
        }
        const customItem = itemList.find((item) => item.id == product.id);
        if (customItem && customItem.id != '0') {
          product.useCustomName = customItem.useCustomName;
          product.cornerMark = customItem.cornerMark || cardBaseConfig.cornerMark;
          product.title = customItem.useCustomName ? customItem.name : product.title;
          // 商品维度，商品图片、价格、跳转地址均要实时获取
          if (productType !== '商品id') {
            product.url = customItem.url || product.url;
            product.price = customItem.price || product.price;
            product.image = ((customItem.image && customItem.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2') < 0) ? customItem.image : product.image) || product.image;
          }
        }
      });

      if (this.pageId == '17701912601330096' && this.props['customAttributes']['data-component-id'] == 'pipeline-productLayout3-1770192375034' && this.top_id) {
        // 2026情人节会场指定页面，指定组件ID，顶部商品置顶（基于配色ID）
        const topGoodsIdx = list.findIndex((item) => item.id == this.top_id);
        if (topGoodsIdx >= 0) {
          const topGoods = list[topGoodsIdx];
          list.splice(topGoodsIdx, 1);
          list.unshift(topGoods);
        }
      }

      return list
    }
  }

  getCollectIds = async(itemCollectList, goodsDataConfig) => {
    const { productType } = goodsDataConfig;
    const idList = [];
    itemCollectList.forEach((item) => {
      if (item.id) {
        idList.push({
          id: Number(item.id),
          limit: isNaN(item.limit) ? 20 : Number(item.limit),
          source: productType === '商品集合id' ? 1 : 2,
        });
      }
    });
    const result = await Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-goodssetapi/set/lego?token=7a08a813-faf1-03e5-d547-cf6bdd1c9ddb&client_name=theme',
      method: "post",
      withCredentials: true,
      data: {
        idList,
      },
    });
    const { status, data } = result.data;
    if (status === 0) {
      const collectList = data || [];
      const collectIds = [];
      collectList.forEach(item => {
        const list = item.list || [];
        list.forEach(value => {
          const id = productType === '商品集合id' ? value.goods_id : value.style_id;
          if (!collectIds.includes(id)) {
            collectIds.push(id);
          }
        })
      });

      return collectIds;
    } else {
      return [];
    }
  }

  getCollectListData = async(collectIds = [], goodsDataConfig) => {
    const { url, params } = this.getIdsReqConf(collectIds, goodsDataConfig);
    const result = await Request({
      url,
      method: "post",
      withCredentials: true,
      data: params
    });
    const { status, data } = result.data;
    if (status === 0) {
      let list = data.List;
      if (this.props.config.cardBaseConfig.cornerMark) {
        list = list.map(item => {
          item['cornerMark'] = this.props.config.cardBaseConfig.cornerMark;
          return item;
        })
      }
      return list;
    } else {
      return [];
    }
  }

  // 滚动监听
  onScroll = (event) => {
    const element = this.goodsBodyRef;
    if (event.target === document && element) {
      const { verticalVisible, visibilityRatio } = this.isElementInViewport(element);
      if (verticalVisible && visibilityRatio >= 0.5) {
        // 进去可视区，切露出超过一半时，开始自动轮播
        this.inViewArea = true;
        this.startScrolling();
      } else {
        // 停止轮播
        this.inViewArea = false;
        this.stopScrolling();
      }
    }
  }

  getScrollPosition = () => {
    if (!this.isScrollEnd) {
      const elementRect = this.goodsScrollRef.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const rightEdgeVisible = elementRect.right <= viewportWidth - 16;
      if (rightEdgeVisible) {
        this.isScrollEnd = true;
      } else {
        const offset = window.innerWidth - this.goodsBodyRef.clientWidth;
        const progressWidth = this.carouselBgRef.clientWidth - this.progressRef.clientWidth;
        const progressLeft = ((this.goodsScrollRef.clientWidth - (elementRect.right - (offset / 2))) / (this.goodsScrollRef.clientWidth - viewportWidth + offset)) * progressWidth;
        this.progressRef.style.left = progressLeft + 'px';
      }
      return this.isScrollEnd; 
    } else {
      return true; 
    }
  }

  requestAnimationFrameScroll = () => {
    const isScrollEnd = this.getScrollPosition();
    // 处理实时滚动位置的逻辑
    if (!isScrollEnd) {
      this.scrollAnimation = requestAnimationFrame(this.requestAnimationFrameScroll);
    } else {
      // 滚动到底了
      cancelAnimationFrame(this.scrollAnimation);
      const offset = window.innerWidth - this.goodsBodyRef.clientWidth;
      this.scrollAnimation = null;
      this.goodsScrollRef.style.animationPlayState = 'paused';
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: this.goodsScrollRef.clientWidth - window.screen.width + offset
      });
      this.goodsScrollRef.style.animation = 'none';
    }
  };

  getAnimationDuration = () => {
    const duration = this.goodsScrollRef.clientWidth / (1316 / 40);
    return parseInt(duration);
  }

  // 多个商品自动适配，滚动监听
  onScrollLayoutRow = () => {
    if (this.props.config.cardBaseConfig.isAutoCarousel === '否') {
      return;
    }
    if (this.initLayoutRowScroll) {
      return;
    }
    this.initLayoutRowScroll = true;
    const goodsBody = this.goodsBodyRef;
    const progressBg = this.carouselBgRef;
    const progress = this.progressRef;
    if (goodsBody && progressBg && progress) {
      const goodsScrollWidth = goodsBody.scrollWidth - goodsBody.clientWidth;
      const progressWidth = progressBg.clientWidth - progress.clientWidth;
      goodsBody.addEventListener('scroll', () => {
        if (goodsBody.scrollLeft >= goodsScrollWidth) {
          this.isScrollEnd = true;
        }
        const progressLeft = (goodsBody.scrollLeft / goodsScrollWidth) * progressWidth;
        progress.style.left = progressLeft + 'px';
      });
    }

    this.handleScrollEvent();
  }

  handleScrollEvent = () => {
    if (!this.goodsScrollRef) {
      return;
    }
    this.goodsScrollRef.addEventListener('touchstart', () => {
      if (this.goodsScrollRef.style.animationPlayState == 'paused' || !this.inViewArea) {
        return;
      }
      this.goodsScrollRef.style.animationPlayState = 'paused';
      this.setGoodsBodyScrollLeft();
      this.goodsScrollRef.style.animation = 'none';
    });

    this.goodsScrollRef.addEventListener('touchend', () => {
      if (!this.inViewArea) {
        return;
      }
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
        this.delayTimeout = null;
      }
      this.delayTimeout = setTimeout(() => {
        if (!this.isScrollEnd) {
          const animationDuration = this.getAnimationDuration();
          const animation = `scrollAnimation ${animationDuration}s linear 0s forwards`;
          this.goodsScrollRef.style.animation = animation;
        }
      }, 1500)
      
    });
  }

  // 设置 goods-body 的scrollLeft
  setGoodsBodyScrollLeft = () => {
    var transformStyle = window.getComputedStyle(this.goodsScrollRef).getPropertyValue('transform');
    var matrix = new window.WebKitCSSMatrix(transformStyle);
    var pausePosition = matrix.m41;
    var goodsScrollLeft = this.goodsBodyRef.scrollLeft;

    if (pausePosition != 0) {
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: -pausePosition + goodsScrollLeft
      })
    }
  }

  // 开始轮播
  startScrolling = () => {
    if (this.scrollState === 'paused') {
      this.scrollState = 'running';
      if (!this.isScrollEnd) {
        const animationDuration = this.getAnimationDuration();
        const animation = `scrollAnimation ${animationDuration}s linear 1s forwards`;
        this.goodsScrollRef.style.animation = animation;
        this.scrollAnimation = requestAnimationFrame(this.requestAnimationFrameScroll);
      }
    }
  }

  // 停止轮播
  stopScrolling = () => {
    this.scrollState = 'paused';
    cancelAnimationFrame(this.scrollAnimation);
    this.scrollAnimation = null;
    this.goodsScrollRef.style.animationPlayState = 'paused';
    if (this.isScrollEnd) {
      // 滚动到底部时，移除css animaton
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: this.goodsScrollRef.clientWidth - window.screen.width
      });
      this.goodsScrollRef.style.animation = 'none';
    } else {
      this.setGoodsBodyScrollLeft();
      this.goodsScrollRef.style.animation = 'none';
    }
  }

  onTitleClick = (href) => {
    if (href) {
      utils.jumpToUrl(this.props.routeParams, href, href, {}, -1, this.props, false); 
    }
  }

  onTabClick = (index, tabText = '') => {
    utils.uploadTrack(this.props, { sort: index }, {
      ptiId: `${this.props.templatePti}:pipeline-productLayout3-tab:${index}`,
      bizExtra: {
        model_block: 'tab',
        tabChName: tabText || ''
      }
    });

    const { cardBaseConfig } = this.props.config;
    if (this.tabFixed && this.compOffsetTop > 0 && this.tabRef) {
      window.scrollTo(0, this.compOffsetTop + this.tabRef.clientHeight + 1);
    }

    if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum) && cardBaseConfig.isAutoCarousel === '是') {
      this.stopScrolling();
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: 0
      });
    }

    this.setState({
      currentIdx: index
    }, () => {
      this.updateTabPosition();
    });
  }

  // AI主题换一换
  onSwitchClick = () => {
    utils.uploadTrack(this.props, {}, {
      ptiId: `${this.props.templatePti}:pipeline-productLayout3-switch`,
      bizExtra: {
        model_block: 'switch'
      }
    });
    let { tabList,  currentIdx } = this.state;
    if (currentIdx + 1 < tabList.length) {
      currentIdx = currentIdx + 1;
    } else {
      currentIdx = 0;
    }
    this.setState({
      currentIdx
    })
  }

  getTrackData(item, index) {
    const { templatePti } = this.props;
    const { tabList, currentIdx } = this.state;
    const { theme, baseConfig, tabConfig, goodsDataConfig } = this.props.config;
    const options = {
      title: baseConfig.title,
      sort: index,
      name: item.title
    };
    if (goodsDataConfig.productType === "商品id") {
      options['goods_id'] = item.id;
    } else {
      options['style_id'] = item.id;
    }

    let ptiOptions = {}
    if (theme === 'AI主题') {
      ptiOptions = {
        ptiId: `${templatePti}:pipeline-productLayout3-switch_${currentIdx}-goods:${index}`,
        bizExtra: {
          goods_id: item.goods_id || '',
          style_id: item.style_id || '',
          sku_id: item.sku_id || '',
          tabChName: '',
          model_block: 'goods',
        }
      }
    } else {
      if (tabConfig.tabType === '无Tab') {
        ptiOptions = {
          ptiId: `${templatePti}:pipeline-productLayout3:${index}`,
          bizExtra: {
            goods_id: item.goods_id || '',
            style_id: item.style_id || '',
            sku_id: item.sku_id || '',
            tabChName: '',
            model_block: 'goods',
          }
        }
      } else {
        const tabChName = (tabList && tabList[currentIdx]) ? (tabList[currentIdx].tabText || '') : '';
        options['tabChName'] = tabChName;
        ptiOptions = {
          ptiId: `${templatePti}:pipeline-productLayout3-tab_${currentIdx}-goods:${index}`,
          bizExtra: {
            goods_id: item.goods_id || '',
            style_id: item.style_id || '',
            sku_id: item.sku_id || '',
            tabChName: tabChName,
            model_block: 'goods',
          }
        }
      }
    }

    return {
      options,
      ptiOptions
    }
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }
    const { options, ptiOptions } = this.getTrackData(item, index);
    const convertUrl = utils.convertHref(item.url); 
    utils.jumpToUrl(this.props.routeParams, convertUrl, convertUrl, options, item.id, this.props, false, ptiOptions);
  }

  // 更新被选中Tab的位置
  updateTabPosition = () => {
    const offsetWidth = this.tabRef.offsetWidth;
    const activeTab =  this.tabRef.querySelector('.active');
    if (activeTab) {
      const tabItemOffsetLeft = activeTab.offsetLeft; // 元素距离左边距离
      const checkedItemWidth = activeTab.offsetWidth;
      const move = tabItemOffsetLeft - (offsetWidth / 2 - checkedItemWidth / 2);
      if (this.tabRef.scrollWidth > offsetWidth) {
        this.tabRef.scroll({
          top: 0,
          left: move,
          behavior: 'smooth',
        });
      }
    }
  }

  // 占开更多
  onExpandMore = () => {
    const { tabConfig } = this.props.config;
    let { list, tabList, currentIdx, showAll, showNum } = this.state;
    if (tabConfig.tabType === '无Tab') {
      utils.uploadTrack(this.props, {}, {
        ptiId: `${this.props.templatePti}:pipeline-productLayout3-more`,
        bizExtra: {
          model_block: 'more',
          tabChName: ''
        }
      });

      if (showNum < list.length) {
        if (showNum + 6 < list.length) {
          showAll = false;
          showNum = showNum + 6;
        } else {
          showAll = true;
          showNum = list.length;
        }
      } else {
        showAll = true;
        showNum = list.length;
      }

      this.setState({
        showAll,
        showNum
      });
    } else {
      utils.uploadTrack(this.props, {}, {
        ptiId: `${this.props.templatePti}:pipeline-productLayout3-tab_${currentIdx}-more`,
        bizExtra: {
          model_block: 'more',
          tabChName: (tabList && tabList[currentIdx]) ? (tabList[currentIdx].tabText || '') : ''
        }
      });
      const { showNum } = tabList[currentIdx];
      if (showNum < tabList[currentIdx].itemList.length) {
        if (showNum + 6 < tabList[currentIdx].itemList.length) {
          tabList[currentIdx]['showNum'] = showNum + 6; 
          tabList[currentIdx]['showAll'] = false;
        } else {
          tabList[currentIdx]['showNum'] = tabList[currentIdx].itemList.length; 
          tabList[currentIdx]['showAll'] = true;
        }
      }
      this.setState({
        tabList
      });
    }
  }

  // 渲染横滑卡片
  renderHorizontalList = (list = []) => {
    const { cardBaseConfig } = this.props.config;
    const renderList = (list = [], midIdx = 0) => {
      return (
        <div className="scroll-list">
          {
            list && list.length > 0 && list.map((item, index) => {
              let others = '';
              switch (cardBaseConfig.displayPriceInfo) {
                case '原价':
                  if (item.original_price > 0) {
                    others = `¥${item.original_price}`
                  }
                  break;
                case '折扣':
                  // 折扣计算
                  if (item.original_price > 0 && item.price < item.original_price) {
                    let rate = item.price / item.original_price;
                    rate = parseFloat((rate * 10).toFixed(1));
                    others = `${rate}折`
                  }
                  break;
                case '直降':
                  let reduce = 0;
                  if (item.original_price && item.original_price > item.price) {
                    reduce = Math.floor(item.original_price - item.price);
                  }
                  if (reduce > 0) {
                    others = `直降${reduce}`;
                  }
                  break;
                case '销量':
                  others = `已售${item.sell_point_str}`
                  break;
                default:
                  break;
              }

              if (!others && item.price) {
                others = '爆款好价';
              }

              if (cardBaseConfig.displayPriceInfo === '不展示价格信息') {
                others = '';
              }

              let price = item.price;
              if (price > 9999) {
                price = `${parseFloat((price / 10000).toFixed(1))}w`
              }

              const { options, ptiOptions } = this.getTrackData(item, midIdx + index);

              return (
                <li
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, options, ptiOptions))}
                  key={`card-${midIdx + index + 1}`}
                  className={`card-item ${cardBaseConfig.showCardMask === '否' ? 'hide-mask' : 'show-mask'}`}
                  style={{
                    backgroundColor: cardBaseConfig.cardBgColor
                  }}
                  onClick={() => this.handleItemClick(item, midIdx + index)}
                >
                  <LazyLoadImage
                    width={px2rem('104px')}
                    height={px2rem('104px')}
                    effect="opacity"
                    className="image"
                    src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                  />
                  <p className="name" style={{color: cardBaseConfig.productNameColor}}>{item.title}</p>
                  <div
                    className="price-info"
                    style={{
                      backgroundImage:`url(${cardBaseConfig.priceBgImageSmall || 'https://static.shihuocdn.cn/admin/files/20250313/941bfb8dd1892e93148758d9fb3d526f.png'})`,
                      backgroundSize: 'conatin',
                      backgroundRepeat: 'no-repeat'
                    }}
                  >
                    {item.id && item.price && <p className="price" style={{color: cardBaseConfig.priceColor}}><span>¥</span>{item.price}</p>}
                    {item.id && others && <p className="others" style={{color: cardBaseConfig.priceInfoColor}}>{others}</p>}
                  </div>
                  {
                    item.cornerMark && <img src={utils.formatImgUrl(item.cornerMark, this.props.webpSupport, 'card')} alt="" className="corner-mark" />
                  }
                </li>
              )
            })
          }
        </div>
      )
    }
    if (cardBaseConfig.displayLineNum === '1行多个（横滑）') {
      return (
        <ul className="list horizontal-list" ref={ref => this.goodsBodyRef = ref}>
          <div className="goods-scroll" ref={ref => this.goodsScrollRef = ref}>
            { renderList(list) }  
          </div>
        </ul>
      );
    } else {
      const midIdx = Math.ceil(list.length / 2); // 计算中间索引，向上取整  
      const list1 = list.slice(0, midIdx);  // 前半部分  
      const list2 = list.slice(midIdx);     // 后半部分      
      return (
        <ul className="list horizontal-list" ref={ref => this.goodsBodyRef = ref}>
         <div className="goods-scroll" ref={ref => this.goodsScrollRef = ref}>
          { renderList(list1) }
          { renderList(list2, midIdx) }
         </div>
        </ul>
      )
    }
  }

  renderVerticalList = (list = [], showNum) => {
    const { cardBaseConfig } = this.props.config;
    return (
      <ul className="list vertical-list">
        {
          list && list.length > 0 && list.slice(0, showNum).map((item, index) => {
            let others = '';
            switch (cardBaseConfig.displayPriceInfo) {
              case '原价':
                if (item.original_price > 0) {
                  others = `¥${item.original_price}`
                }
                break;
              case '折扣':
                // 折扣计算
                if (item.original_price > 0 && item.price < item.original_price) {
                  let rate = item.price / item.original_price;
                  rate = parseFloat((rate * 10).toFixed(1));
                  others = `${rate}折`
                }
                break;
              case '直降':
                let reduce = 0;
                if (item.original_price && item.original_price > item.price) {
                  reduce = Math.floor(item.original_price - item.price);
                }
                if (reduce > 0) {
                  others = `直降${reduce}`;
                }
                break;
              case '销量':
                others = `已售${item.sell_point_str}`
                break;
              default:
                break;
            }
            if (!others && item.price) {
              others = '爆款好价';
            }
            if (cardBaseConfig.displayPriceInfo === '不展示价格信息') {
              others = '';
            }

            let price = item.price;
            if (price > 9999) {
              price = `${parseFloat((price / 10000).toFixed(1))}w`
            }

            const { options, ptiOptions } = this.getTrackData(item, index);

            return (
              <li
                ref={ele => {
                  if (ele) {
                    this.props.exp && this.props.exp(ele);
                  }
                }}
                data-dot={JSON.stringify(utils.getExposureData(this.props, options, ptiOptions))}
                className={`card-item ${cardBaseConfig.showCardMask === '否' ? 'hide-mask' : 'show-mask'}`}
                key={`card-${index + 1}`}
                style={{
                  backgroundColor: cardBaseConfig.cardBgColor
                }}
                onClick={() => this.handleItemClick(item, index)}
              >
                <LazyLoadImage
                  width={px2rem('111px')}
                  height={px2rem('111px')}
                  effect="opacity"
                  className="image"
                  src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                />
                <p className="name" style={{color: cardBaseConfig.productNameColor}}>{item.title}</p>
                <div
                  className="price-info"
                  style={{
                    backgroundImage:`url(${cardBaseConfig.priceBgImage || 'https://static.shihuocdn.cn/admin/files/20241223/69ea17e2f62b1a99387bda573fe01f9d.png'})`,
                    backgroundSize: 'conatin',
                    backgroundRepeat: 'no-repeat'
                  }}
                >
                  {item.id && item.price && <p className="price" style={{color: cardBaseConfig.priceColor}}><span>¥</span>{price}</p>}
                  {item.id && others && <p className="others" style={{color: cardBaseConfig.priceInfoColor}}>{others}</p>}
                </div>
                {
                  item.cornerMark && <img src={utils.formatImgUrl(item.cornerMark, this.props.webpSupport, 'card')} alt="" className="corner-mark" />
                }
              </li>
            )
          })
        }
      </ul>
    )
  }

  // 渲染常规一行三卡片（无Tab）
  renderNormalList = (list = [], showNum) => {
    const { cardBaseConfig } = this.props.config;
    if (['1行多个（横滑）', '2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)) {
      return this.renderHorizontalList(list, showNum);
    } else {
      return this.renderVerticalList(list, showNum);
    }
  }

  // 渲染Tab切换一行三卡片
  renderTabList = () => {
    const { tabList, currentIdx } = this.state;
    if (tabList.length > 0) {
      return (
        <Fragment>
          { this.renderNormalList(tabList[currentIdx].itemList, tabList[currentIdx].showNum) }
          { this.renderExpandMore(tabList[currentIdx].showAll) }
        </Fragment>
      ) 
    } else {
      return null;
    }
  }

  // 渲染Tab
  renderTabNav = () => {
    const { tabConfig } = this.props.config;
    const { tabList, currentIdx } = this.state;
    let className = tabList.length > 4 ? 'fixedWidth' : 'flexWidth';
    if (tabConfig.tabType === '文字Tab') {
      // 文字Tab
      return (
        <ul
          className="text-tab"
          style={{
            minHeight: px2rem(`${tabConfig.tabSize.height || 0}px`),
            // top: this.props.navigationBarHeight
          }}
          ref={ref => this.tabRef = ref}
        >
          {
            tabList && tabList.length > 0 && tabList.map((item, index) => {
              return (
                <li
                  className={index === currentIdx ? `${className} active` : className}
                  key={`tab-${index}`}
                  style={{
                    backgroundColor: index === currentIdx ? tabConfig.tabActiveBgColor : tabConfig.tabUnActiveBgColor,
                    color: index === currentIdx ? tabConfig.tabActiveTextColor : tabConfig.tabUnActiveTextColor,
                  }}
                  onClick={() => this.onTabClick(index, item.tabText)}
                >
                  {this.tabCharacters(item.tabText, 10)}
                </li>
              )
            })
          }
        </ul>
      ) 
    } else {
      const tabNum = tabList.length <= 5 ? tabList.length : 'auto'
      // 图片Tab
      return (
        <ul
          className="image-tab"
          style={{
            minHeight: px2rem(`${tabConfig.tabSize.height || 0}px`),
            // top: this.props.navigationBarHeight
          }}
          ref={ref => this.tabRef = ref}
        >
          {
            tabList && tabList.length > 0 && tabList.map((item, index) => {
              return (
                <li
                  className={index === currentIdx ? `tab-num-${tabNum} active` : `tab-num-${tabNum}`}
                  key={`tab-${index}`}
                  onClick={() => this.onTabClick(index, item.tabText)}
                >
                  <LazyLoadImage
                    effect="opacity"
                    className="un-active"
                    visibleByDefault={this.isIframe}
                    src={utils.formatImgUrl(item.tabUnActiveBgImage, this.props.webpSupport)}
                  />
                  <LazyLoadImage
                    effect="opacity"
                    className="active"
                    visibleByDefault={this.isIframe}
                    src={utils.formatImgUrl(item.tabActiveBgImage, this.props.webpSupport)}
                  />
                </li>
              )
            })
          }
        </ul>
      )
    }
  }

  // 渲染查看更多按钮
  renderExpandMore = (showAll) => {
    const { baseConfig, cardBaseConfig } = this.props.config;
    if (['1行', '2行'].includes(cardBaseConfig.displayLineNum)) {
      if (!showAll) {
        return (
          <div
            className="expand" 
            style={{
              color: baseConfig.browserMoreColor,
            }}
            onClick={() => this.onExpandMore()}
          >
            查看更多
            <svg t="1735023368687" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="16874" width="200" height="200">
              <path d="M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z" p-id="16875" fill={baseConfig.browserMoreColor || '#666666'}></path>
            </svg>
          </div>
        ) 
      } else {
        return (
          <div className="line" style={{height: px2rem('8px')}}></div>
        )
      } 
    } else {
      return (
        <div className="line" style={{height: cardBaseConfig.isAutoCarousel === '是' ? px2rem('10px') : px2rem('8px')}}>
          { cardBaseConfig.isAutoCarousel === '是' && this.renderCarouselBar() }
        </div>
      )
    }
  }

  // 渲染常规主题
  renderNormalTheme() {
    const { baseConfig, tabConfig, tabList } = this.props.config;
    const { list, showAll, showNum } = this.state;
    const isRenderTab = tabConfig.tabType !== '无Tab' && tabList && tabList.length > 1;
    const showTitle = baseConfig.title && baseConfig.showTitle;
    const { backgroundColorType, titleBackgroundColor, titleBgColorFrom, titleBgColorTo, backgroundColor, titleImage, titleHref, titleColor, title } = baseConfig || {};
    const titleStyle = 
      backgroundColorType == "纯色背景"
      ? { backgroundColor: backgroundColorType == "纯色背景" ? titleBackgroundColor : '#FFFFFF' }
      : { background: backgroundColorType == "渐变色背景" ? `linear-gradient(180deg, ${utils.hexColorToRgba(titleBgColorFrom, 1)} 0%, ${utils.hexColorToRgba(titleBgColorTo, 1)} 100%), #FFFFFF` : '#FFFFFF' };
    const { width, height } = utils.getAdaptImageSize(baseConfig.titleImageSize);
    return (
      <div className="theme-normal-wrap">
        <div style={{ position: 'relative' }}>
          { backgroundColorType == "图片背景" && titleImage && 
            <LazyLoadImage
              className="title-image"
              src={utils.formatImgUrl(titleImage, this.props.webpSupport)}
              style={{
                width: '100%',
                height
              }}
              visibleByDefault={true}
              onClick={() => this.onTitleClick(titleHref)}
            />
          }
          <div
            className={`title ${showTitle ? 'show' : 'hide'}`}
            style={{
              color: titleColor,
              ...titleStyle,
              ...(backgroundColorType == "图片背景" && titleImage ? {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'transparent'
              } : {})
            }}
            onClick={() => this.onTitleClick(titleHref)}
          >
            {
              showTitle && (
                <Fragment>
                  <p className="title-text">{this.tabCharacters(title, 28)}</p>
                  {
                    title 
                    && titleHref
                      && <svg t="1735026654807" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="17123" width="200" height="200"><path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="17124" fill={baseConfig.titleColor}></path></svg>
                  }
                </Fragment>
              )
            }
          </div>
        </div>
        {/* {
          baseConfig.titleImage
            ? (
              <LazyLoadImage
                className="title-image"
                src={utils.formatImgUrl(baseConfig.titleImage, this.props.webpSupport)}
                style={{
                  width: '100%',
                  height
                }}
                visibleByDefault={true}
                onClick={() => this.onTitleClick(baseConfig.titleHref)}
              />
            )
            : (
              <div
                className={`title ${showTitle ? 'show' : 'hide'}`}
                style={{
                  backgroundColor: baseConfig.backgroundColor,
                  color: baseConfig.titleColor
                }}
                onClick={() => this.onTitleClick(baseConfig.titleHref)}
              >
                {
                  showTitle && (
                    <Fragment>
                      {this.tabCharacters(baseConfig.title, 28)}
                      {
                        baseConfig.title 
                        && baseConfig.titleHref
                          && <svg t="1735026654807" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="17123" width="200" height="200"><path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="17124" fill={baseConfig.titleColor}></path></svg>
                      }
                    </Fragment>
                  )
                }
              </div>
            )
        } */}
        <div
          className="content"
          style={{
            backgroundColor: backgroundColor
          }}
        >
          { isRenderTab && this.renderTabNav() }
          
          { tabConfig.tabType === '无Tab' ? this.renderNormalList(list, showNum) : this.renderTabList() }

          { tabConfig.tabType === '无Tab' && this.renderExpandMore(showAll) }
        </div>
      </div>
    )
  }

  // 渲染AI主题
  renderAiTehme() {
    const { baseConfig, cardBaseConfig } = this.props.config;
    const { tabList, currentIdx } = this.state;
    let list = [], desc = '';
    if ( tabList[currentIdx]) {
      list = tabList[currentIdx].itemList || [];
      desc = tabList[currentIdx].tabText || '';
    }
    return (
      <div className="theme-ai-wrap">
        <div
          className="title-image"
          style={{
            backgroundImage:`url(${baseConfig.moduleBgImage || 'https://static.shihuocdn.cn/admin/files/20250302/efa261cbe66a7fe2b0016e2c9bc0d1eb.png'})`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <img src={baseConfig.robotImage || 'https://static.shihuocdn.cn/admin/files/20250302/c0a19bed08508093799fb73148c081ef.webp'} alt="" className="robot" />
          <div className="tips">
            噔噔！您的AI购物管家上线啦~发现您最近对“<span>{desc}</span>”类的商品很感兴趣，本AI为您精心挑选了以下专属商品哦~
            <img
              src="https://static.shihuocdn.cn/admin/files/20250302/b5f32169cf63e5bed6b861fb9e9b8f2b.png"
              alt=""
              className="switch"
              onClick={() => this.onSwitchClick()}
            />
          </div>
        </div>
        <ul
          className="content"
          style={{
            backgroundColor: baseConfig.backgroundColor
          }}
        >
          {
            list && list.length > 0 && list.slice(0, 6).map((item, index) => {
              const { options, ptiOptions } = this.getTrackData(item, index);
              return (
                <li
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, options, ptiOptions))}
                  className={`card-item ${cardBaseConfig.showCardMask === '否' ? 'hide-mask' : 'show-mask'}`}
                  key={`card-${index + 1}`}
                  style={{
                    backgroundColor: cardBaseConfig.cardBgColor
                  }}
                  onClick={() => this.handleItemClick(item, index)}
                >
                  <LazyLoadImage
                    width={px2rem('106px')}
                    height={px2rem('106px')}
                    effect="opacity"
                    className="image"
                    src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                  />
                  <p className="name" style={{color: cardBaseConfig.productNameColor}}>{item.title}</p>
                  <p className="price" style={{color: cardBaseConfig.priceColor}}><span style={{color: cardBaseConfig.priceColor}}>¥</span>{item.price}</p>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }

  render() {
    const { theme, baseConfig } = this.props.config;

    return (
      <div
        id={this.props['customAttributes']['data-component-id']}
        className={`pipeline-productLayout3 ${theme === 'AI主题' ? 'theme-ai' : 'theme-normal'}`}
        {...this.props['customAttributes']}
        ref={ref => this.compRef = ref}
        name={baseConfig.title}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
        }}
      >
        {
          theme === 'AI主题'
            ? this.renderAiTehme()
            : this.renderNormalTheme()
        }
      </div>
    )
  }

  // 轮播条
  renderCarouselBar() {
    const { cardBaseConfig } = this.props.config;
    let carouselBgColor, progressColor;
    switch (cardBaseConfig.carouselBarColor) {
      case '白色':
        carouselBgColor = 'rgba(255, 255, 255, 0.3)';
        progressColor = '#fff';
        break;
      case '黑色':
        carouselBgColor = 'rgba(202, 202, 202, 0.3)';
        progressColor = '#CACACA';
        break;
      default:
        carouselBgColor = 'rgba(255, 255, 255, 0.3)';
        progressColor = '#fff';
        break;
    }
    return (
      <div className="carousel-bar">
        <div className="carousel-bg" style={{backgroundColor: carouselBgColor}} ref={ref => this.carouselBgRef = ref}></div>
        <div className="carousel-progress" style={{backgroundColor: progressColor}} ref={ref => this.progressRef = ref}></div>
      </div>
    )
  }

  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  
    // 判断元素是否垂直方向上可见
    const verticalVisible = rect.top <= windowHeight && rect.bottom >= 0;
  
    // 判断元素是否水平方向上可见
    const horizontalVisible = rect.left <= windowWidth && rect.right >= 0;
  
    // 计算已经暴露在可视区的比例
    const visibleArea = Math.max(0, Math.min(rect.right, windowWidth) - Math.max(rect.left, 0)) *
      Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
  
    const totalArea = rect.width * rect.height;
    const visibilityRatio = visibleArea / totalArea;
  
    return {
      verticalVisible,
      horizontalVisible,
      visibilityRatio
    };
  }

  // 字符串截取（指定截取的最大长度，每个中文占2个字符，其他占1个字符）
  tabCharacters = (str, limit) => {
    let result = '';
    let maxLength = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charAt(i);
      if (/[\u4e00-\u9fa5]/.test(char)) {
        // 中文
        if (maxLength + 2 <= limit) {
          maxLength += 2;
          result += str[i];
        }
      } else {
        // 其他，如空格、特殊符号等
        if (maxLength + 1 <= limit) {
          maxLength += 1;
          result += str[i];
        }
      }
    }
    return result;
  }
}

PipelineProductLayout3.propTypes = {
  config: PropTypes.object.isRequired,
};
  
export { PipelineProductLayout3 };
export default PipelineProductLayout3;


// WEBPACK FOOTER //
// ./components/pipeline-productLayout3/index.js